import React from "react";
import GridSpotImage from "../../../../common/components/GridSpotImage";
import {
  isGridspotMultiSelect,
  readGridspotSelectedOptionIds,
  toGridspotAnswerValue,
  toggleGridspotAnswerValue,
} from "../../../../helpers/gridspot";

export default function GridSpotAnswer({
  question,
  preview = false,
  value,
  onChange,
  interactive = false,
}) {
  const canInteract = preview && interactive;
  const isMultiSelect = isGridspotMultiSelect(question);
  const selectedIds = readGridspotSelectedOptionIds(value);

  return (
    <GridSpotImage
      question={question}
      selectedOptionIds={selectedIds}
      disabled={!canInteract}
      onSelect={(option, point) => {
        if (!canInteract) return;
        // Carry the normalised tap position so Client Connect records where inside a
        // multi-cell spot the respondent tapped, like the desktop and mobile flows.
        const nextValue = isMultiSelect
          ? toggleGridspotAnswerValue(value, option._id)
          : toGridspotAnswerValue(option._id);
        onChange(nextValue, { gridspot_point: point });
      }}
      onMiss={() => {}}
      alt={
        question?.text
          ? String(question.text).replace(/<[^>]+>/g, "")
          : "Survey image"
      }
    />
  );
}
